const headerDataMonth = [
    {
       prop: "Month",
       label: "月份",
       columnwidth: 140,
     },
     {
       prop: "Jan", 
       label: "1月",
       columnwidth: 64,
     },
     {
       prop: "Feb",
       label: "2月",
       columnwidth: 64,
     },
     {
       prop: "Mar",
       label: "3月",
       columnwidth: 64,
     },
     {
       prop: "Apr",
       label: "4月",
       columnwidth: 64,
     },
     {
       prop: "May",
       label: "5月",
       columnwidth: 64,
     },
     {
       prop: "Jun",
       label: "6月",
       columnwidth: 64,
     },
     {
       prop: "Jul",
       label: "7月",
       columnwidth: 64,
     },
     {
       prop: "Aug",
       label: "8月",
       columnwidth: 64,
     },
     {
       prop: "Sep",
       label: "9月",
       columnwidth: 64,
     },
     {
       prop: "Oct",
       label: "10月",
       columnwidth: 64,
     },
     {
       prop: "Nov",
       label: "11月",
       columnwidth: 64,
     },
     {
       prop: "Dec",
       label: "12月",
       columnwidth: 64,
     }
];
export default headerDataMonth;